import req from "../http";

const appointment = {
  // 取得 任用單
  getAppointment(matchId) {
    return req("get", `/AppointmentModule/Appointment/${matchId}`);
  },

  // 新增 任用單(一般流程)
  postAppointment(params) {
    return req("post", "/AppointmentModule/Appointment", params);
  },

  // 新增 任用單(特殊流程)
  postSkipInterview(params) {
    return req("post", "/AppointmentModule/Appointment/SkipInterview", params);
  },
  

  // 編輯 任用單
  putAppointment(params) {
    return req("put", "/AppointmentModule/Appointment", params);
  },
};

export default appointment;